import axios from 'axios';
//const API_URL = 'http://192.168.0.190/speechor/api/fth-api/';
const API_URL = 'https://speechormanager.univerhome.com/api/fth-api/';
const UDAD_API_URL = 'http://192.168.0.109:8080/api/web_payments'

class UserService {

  	ordernow(item, ref) {
      return axios.post(API_URL,  {
                          "name":"ordernow",
                          "param":{
                                  "product": item,
                                  "referrer": ref
                          }
                      },
                      { headers: {
                            'Content-Type': 'application/json' 
                          }
                      });
    }

    sendMessage(name, email, subject, message) {
          return axios.post(API_URL,  {
                              "name":"sendmessage",
                              "param":{
                                      "name": name,
                                      "email": email,
                                      "subject": subject,
                                      "message": message
                              }
                          },
                          { headers: {
                                'Content-Type': 'application/json' 
                              }
                          });
        }
    getprice() {
          return axios.post(API_URL,  {
                              "name":"getprice",
                              "param":{}
                          },
                          { headers: {
                                'Content-Type': 'application/json' 
                              }
                          });
    } 

    getPaddlePrices() {
          return axios.post(API_URL,  {
                              "name": "getPaddlePrices",
                              "param": {}
                          },
                          { headers: {
                                'Content-Type': 'application/json' 
                              }
                          });
    }

    SavePaddleSubscription(transactionId, email) {
      return axios.post(API_URL,  {
                          "name":"SavePaddleSubscription",
                          "param":{
                                  "transactionId": transactionId,
                                  "email": email
                          }
                      },
                      { headers: {
                            'Content-Type': 'application/json' 
                          }
                      });
    }

    SaveUdadBoostTransaction(transactionId, status, method, token, amount, currency) {
      return axios.post(UDAD_API_URL,  {
                          "action":"save_payment",
                          "transactionId": transactionId,
                          "status": status,
                          "method": method,
                          "amount": amount,
                          "currency": currency
                          
                      },
                      { headers: {
                            'Authorization': 'Bearer '+ token,
                            'Content-Type': 'application/json' 
                          }
                      });
    }
}

export default new UserService();